document.addEventListener('DOMContentLoaded', function() {
    const thumbs = document.querySelectorAll('.story-thumb');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const videoUrl = thumb.dataset.videoUrl;
        // criar overlay
        const overlay = document.createElement('div');
        overlay.className = 'story-overlay';
  
        // botão de fechar
        const btnClose = document.createElement('div');
        btnClose.className = 'btn-close';
        btnClose.innerHTML = '&times;';
        overlay.appendChild(btnClose);
  
        // elemento de vídeo
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        overlay.appendChild(video);
  
        // adicionar ao body
        document.body.appendChild(overlay);
  
        // fechar ao clicar no X ou fora do vídeo
        btnClose.addEventListener('click', () => document.body.removeChild(overlay));
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) document.body.removeChild(overlay);
        });
      });
    });
  });
  